import { useCallback } from 'react';

import { gql } from '@apollo/client';
import { useQuery } from '@apollo/client/react';

import { useOverviewVariables } from './useOverviewVariables';

export interface OverviewResponseTimesData {
  avg_response_time: number | null;
  avg_ai_response_time: number | null;
  ai_response_time_count: number | null;
  avg_human_response_time: number | null;
  human_response_time_count: number | null;
}

interface QueryResponse {
  rows: OverviewResponseTimesData[];
}

export const ACCOUNT_RESPONSE_TIMES_SUMMARY = gql`
  query AccountResponseTimesSummary(
    $startDate: timestamp
    $endDate: timestamp
    $brainIds: _uuid
    $channels: _text
    $deskIds: _uuid
    $isTest: Boolean
    $minNumUserMessages: Int
    $minAvgCsatScore: Float
    $maxAvgCsatScore: Float
  ) {
    rows: account_response_times_summary(
      args: {
        start_time: $startDate
        end_time: $endDate
        brain_parent_ids: $brainIds
        channels: $channels
        desk_ids: $deskIds
        is_test: $isTest
        min_num_user_messages: $minNumUserMessages
        min_avg_csat_score: $minAvgCsatScore
        max_avg_csat_score: $maxAvgCsatScore
      }
    ) {
      avg_response_time
      avg_ai_response_time
      ai_response_time_count
      avg_human_response_time
      human_response_time_count
    }
  }
`;

export const useOverviewResponseTimes = () => {
  const { variables, skip } = useOverviewVariables();

  const { loading, data, error, refetch } = useQuery<QueryResponse>(
    ACCOUNT_RESPONSE_TIMES_SUMMARY,
    { variables, skip }
  );

  const row = data?.rows?.[0] ?? null;

  const onRefetch = useCallback(() => {
    refetch(variables);
  }, [refetch, variables]);

  return { isLoading: loading, error, data: row, onRefetch };
};
